import { MachinesApiService } from '@api/machines'
import {
  handleCatchError,
  setIsPristine,
  TRANSPORT_OPTION_TYPES
} from '@common/utils'
import { useParams } from 'react-router-dom'

export const useChangeContractType = () => {
  const { attachmentId, equipmentId, quoteId, specId } = useParams()

  const isWithinMachine = Boolean(equipmentId && attachmentId)

  const id = quoteId ?? specId

  const changeTransportType = async (selectedOption: string) => {
    if (!(id && equipmentId && attachmentId)) {
      return
    }

    try {
      if (selectedOption === TRANSPORT_OPTION_TYPES.FITTED) {
        await MachinesApiService.quotationMachineMachineAttachmentUpdateTransportAvailability(
          id,
          equipmentId,
          attachmentId,
          true
        )
      }

      if (selectedOption !== TRANSPORT_OPTION_TYPES.FITTED && isWithinMachine) {
        await MachinesApiService.quotationMachineMachineAttachmentUpdateTransportAvailability(
          id,
          equipmentId,
          attachmentId,
          false
        )
      }
      setIsPristine(false)
    } catch (error) {
      handleCatchError(error)
    }
  }

  return { changeTransportType, isWithinMachine }
}
